const FleetStatus = {
  Active: "active",
  InActive: "inactive",
};

export default FleetStatus;
